<template>
  <el-form ref="ref_form" class="set-game-options" :model="interferenceForm" label-width="100px">
    <div v-for="(item, index) in interferenceForm.dataList" :key="index" class="game-cutline">
      <el-form-item label="">
        <el-checkbox v-model="item.state" :true-label="1" :false-label="0">学习内容{{ index + 1 }}是否选用</el-checkbox>
      </el-form-item>
      <el-form-item
        :label="'学习内容' + (index + 1)"
        :prop="'dataList.' + index + '.studyId'"
        :rules="{
          required: item.state === 1, message: '请选择学习内容', trigger: 'change'
        }"
      >
        <el-select v-model="item.studyId" placeholder="请选择" filterable style="width: 500px;" @change="sentenceChange($event, index)">
          <el-option v-for="sentence in item.sentenceList" :key="sentence.id" :label="sentence.desc" :value="sentence.id" />
        </el-select>
      </el-form-item>
      <el-form-item
        label="选择填空词"
        :prop="'dataList.' + index + '.chooseWords'"
        :rules="{
          required: item.state === 1, message: '请选择填空词', trigger: 'change'
        }"
      >
        <el-checkbox-group v-model="item.chooseWords" :max="3" size="small">
          <el-checkbox-button v-for="(word, index2) in item.studySentence" :key="index2" :label="word">{{ word }}</el-checkbox-button>
        </el-checkbox-group>
        <!-- <div style="color: #999;" v-if="getWordsBySentence(item.sentence).length > 10">单词数量已大于10个，无法在app端完美展示，请谨慎使用！</div> -->
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import { mapState } from 'vuex'
import { saveConfData } from '@api/courseManagement/api_quiz'
export default {
  components: {
    // themeUploadList
  },
  props: {
    timestamp: {
      type: Number,
      default: 0
    },
    moduleType: {
      type: String,
      default: ''
    },
    currentQuizType: {
      type: String,
      default: ''
    },
    gameList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      interferenceForm: {
        radio: '',
        dataList: [
          // { sentence: 'what,     is  your name,    is!', chooseWords: [] },
          // { sentence: 'This cat is on the mat This cat is on the mat', chooseWords: [] },
          // { sentence: 'how are you', chooseWords: [] }
        ]
      }

    }
  },
  computed: {
    ...mapState('courseStep', ['courseData', 'stepOptions', 'stepActive'])
  },
  watch: {
    gameList: function (val) {
      this.interferenceForm.dataList = []
      this.gameList.forEach((item, index) => {
        const chooseWords = item.chooseWords ? item.chooseWords.split(',') : []
        const studyId = item.studyId || item.sentenceList[0].id
        this.interferenceForm.dataList.push({ state: item.state, studyId: studyId, name: item.wordName, meansType: item.meansType, chooseWords: chooseWords, sentenceList: item.sentenceList, studySentence: '' })
        // 对于已选中的句子，初始化时处理将句子切割为单词
        this.sentenceChange(studyId, index)
      })
    }
  },

  created () {

  },
  methods: {
    sentenceChange (val, index) {
      // 阅读模块 和 句型模块，学习内容更改时，将选中的对应句子
      const arr = this.interferenceForm.dataList[index].sentenceList
      let name = ''
      for (const item of arr) {
        if (item.id === val) {
          name = item.desc
          break
        }
      }
      this.interferenceForm.dataList[index].studySentence = this.getWordsBySentence(name)
    },
    getWordsBySentence (sentence) {
      const sentenceStr = sentence.replace(/[|\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?/\，/\。/\；/\：/\“/\”/\》/\《/\|/\{/\}/\、/\!/\~/\`]/g, ' ')
      let words = sentenceStr.split(' ')
      words = words.filter(item => {
        return item
      })
      return words
    },
    // 验证干扰项 选择必填项
    isValidateOptions (arr) {
      let flag = false
      let checkTotal = 0
      // const arr = _.cloneDeep(this.interferenceForm.dataList)
      for (let i = 0; i < arr.length; i++) {
        checkTotal = checkTotal + arr[i].state
      }
      if (checkTotal === 0) {
        this.$message.error(`请至少选中一条学习内容`)
        flag = true
        return flag
      }
      return flag
    },

    saveGameOptions () {
      this.$refs.ref_form.validate(valid => {
        if (!valid) { return false }
        if (this.isValidateOptions(this.interferenceForm.dataList)) {
          return false
        }
        this.interferenceForm.dataList.forEach(item => {
          item.chooseWords = item.chooseWords.toString()
        })
        const params = {
          curriculumId: this.courseData.teachingCurriculumId,
          curriculumType: this.courseData.curriculumType,
          quizType: this.currentQuizType,

          items: this.interferenceForm.dataList
        }

        saveConfData(params).then(res => {
          this.$message.success('操作成功')
          this.$emit('finishSave')
        })
      })
    }
  }
}
</script>

<style lang='scss'>
.game-cutline{
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  margin-bottom: 30px;
}

</style>
